import {MsalService} from "@azure/msal-angular";
import {IPublicClientApplication} from "@azure/msal-browser";
import {inject} from "@angular/core";
import {BsThemeService} from "./shared/service/bs-theme.service";
import {BsTheme} from "./shared/models/bs-theme.model";
import {environment} from "../environments/environment";

// export function initializeApp(configService: ConfigService) {
//   return () => configService.loadConfig();
// }


// export function initializeApp(store: Store<AppState>): () => Promise<boolean> {
//   return () => {
//     // return new Promise<boolean>(resolve => {
//     //   // store.dispatch(loadData());
//     //
//     //   resolve(false);
//     // });
//     console.log('GOT TO initializeApp ')
//    return new Promise<boolean>(resolve => setTimeout(resolve, 5000));
//   };
// }
export async function initializeApp(): Promise<void> {
  const authService = inject(MsalService);
  const themeService = inject(BsThemeService);

  const element = document.querySelector('html');
  const isDarkMode = document.querySelector('html.my-app-dark');

  const darkModeSelected = localStorage.getItem("darkModeSelected");
  if (darkModeSelected === 'true'){
    if (!isDarkMode) {
      element?.classList.add('my-app-dark');
    }
    themeService.setTheme(BsTheme.DARK);
  } else {
    if (isDarkMode) {
      element?.classList.remove('my-app-dark');
    }
    themeService.setTheme(BsTheme.LIGHT);
  }

  await clearAccountsFromOtherPolicies(authService.instance, environment.config.auth.authority);

  // const userIsLoggedIn = authService.instance.getAllAccounts().length > 0;
  // if (!userIsLoggedIn){
  //   console.log('initializeApp redirect got here')
  // }
}

// B2C stamps the issuing policy into `tfp` (`acr` on legacy tokens) and the API
// rejects tokens from any other policy, so an account cached under a previous
// sign-in policy can only ever produce 401s until it is dropped.
export async function clearAccountsFromOtherPolicies(instance: IPublicClientApplication, authority: string): Promise<void> {
  await instance.initialize();
  const policyId = authority.replace(/\/+$/, '').split('/').pop()?.toLowerCase() ?? '';

  for (const account of instance.getAllAccounts()) {
    const issuedBy = (account.idTokenClaims?.tfp ?? account.idTokenClaims?.acr ?? '').toLowerCase();
    if (issuedBy === policyId) continue;
    await instance.clearCache({ account });
  }
}
